import { config_settings } from '@/config.js';
import Vue from 'vue';

export const postCdpCashPay = (token, formData) => {
  return Vue.$http({
    method: 'post',
    url: config_settings.RESOURCE_SERVER_URL + '/POST/cdp-cashpay',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    data: formData,
  });
};

export const postCdpPagoLink = (token, formData) => {
  return Vue.$http({
    method: 'post',
    url: config_settings.RESOURCE_SERVER_URL + '/POST/cdp-pagolink',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    data: formData,
  });
};

export const postCdpNiubiz = (token, chargueData) => {
  return Vue.$http({
    method: 'post',
    url: config_settings.RESOURCE_SERVER_URL + '/POST/cdp-visanet',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    data: chargueData,
  });
};

export const getPaymentMethods = (token) => {
  return Vue.$http({
    method: 'get',
    url: config_settings.RESOURCE_SERVER_URL + '/GET/payment_methods',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const evaluateCouponsCode = (discountCode) => {
  return Vue.$http({
    method: 'post',
    url: config_settings.RESOURCE_SERVER_URL + '/POST/couponsxpromocodexdates/' + discountCode,
  });
};

